import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';

/**
 * Source de vérité pour les langues supportées.
 * Pour ajouter une langue : ajouter un objet ici + créer locales/<code>.json
 *
 * isDefault: true  → langue par défaut, pas de préfixe URL  (ex: /dashboard)
 * isDefault: false → langue préfixée dans l'URL             (ex: /en/dashboard)
 */
export const SUPPORTED_LANGS = [
  { code: 'fr', label: 'Français', isDefault: true },
  { code: 'en', label: 'English',  isDefault: false },
];

/** Codes ISO des langues supportées (pour i18next supportedLngs) */
export const SUPPORTED_LANG_CODES = SUPPORTED_LANGS.map((l) => l.code);

/** Langue par défaut */
export const DEFAULT_LANG = SUPPORTED_LANGS.find((l) => l.isDefault);

/** Retourne la config d'une langue depuis son code (ex: getLang('en')) */
export function getLang(code) {
  return SUPPORTED_LANGS.find((l) => l.code === code) ?? DEFAULT_LANG;
}

// Construit les resources i18next depuis SUPPORTED_LANGS
const locales = { fr, en };
const resources = Object.fromEntries(
  SUPPORTED_LANGS.map((l) => [l.code, { translation: locales[l.code] }])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANG.code,
    supportedLngs: SUPPORTED_LANG_CODES,
    detection: {
      // Priority: URL path prefix > localStorage > navigator
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
